export class MathUtils {
  static roundDown(value: number, decimals: number): number {
    const factor = 10 ** decimals;
    return Math.floor(value * factor) / factor;
  }
}
